import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import ButtonBase from '@material-ui/core/ButtonBase';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import PerfectScrollbar from 'react-perfect-scrollbar';

import {api_host, api_auth} from '../../../../common/globals/constants';

// Component styles
import styles from './styles';

const sendValues = (notificacion, objetivo_id, user, admin_id) => {
	let token = sessionStorage.getItem('key')

    let method = 'DELETE'

    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/alertas/?token=${token}`, {
                method: method, // or 'PUT'
                body: JSON.stringify({token: token, objetivo_id: objetivo_id, notificacion: notificacion, user: user, admin: admin_id}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 3) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};

class NotificationsObjectiveList extends Component {

	constructor(props) {
		super(props);
		
        this.state = {
            props: props,
            settingsEl: null,
            value: 0,
			updateDisabled: true,
			dataError: false,
			isLoading: true, 
			isValid: false,
			submitError: null,  
			open: false     
		}
	}
	
	componentDidMount() {
        this.getDataFromAPI();
    }

	getDataFromAPI = (objectiveId) => {
		const { objetivo_id } = this.props.params.match.params
		let token = sessionStorage.getItem('key')
		Promise.all([
			fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/alertas/?token=${token}`),
			fetch(api_host+`/reporte/general/horarios/?token=${token}`),
			fetch(api_host+`/reporte/general/destinatarios/?order=0&token=${token}`)
		])
			.then(([res1, res2, res3]) => {
				return Promise.all([res1.json(), res2.json(), res3.json()])
			})
			.then(([res1, res2, res3]) => {
				// Se define el state de acuerdo a la petición y respuesta de la promesa 
				if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
					localStorage.setItem('isAuthenticated', false);
				} else {
					//Procesa la Data Recibida
					try {					
						this.processData(res1, res2, res3)
						/*if (this.state.lastEvent !== []) {
							this.props.params.onFirstInfo(this.state.lastEvent)
						}*/
					} catch (error) {
						this.setState({
							dataError: true,
							data: null,
							isLoading: false
						});
					}
				}
			});
	}

	// Helper para procesar la data de la petición a la API

    processData = (dataAlertas, dataHorarios, dataDestinatarios) => {
		
		sessionStorage.setItem('user_schedules', JSON.stringify(dataHorarios))
		sessionStorage.setItem('user_addressee', JSON.stringify(dataDestinatarios[0]))

		this.setState({
			alertas: dataAlertas,
			horarios: dataHorarios,
			destinatarios: dataDestinatarios[0],
			dataError: false,
            isLoading: false,
		})
	}

	handleDeleted = async event => {
		const { objetivo_id } = this.props.params.match.params
		let user = sessionStorage.getItem('user')
        let admin_id = sessionStorage.getItem('admin_id')
		try {
            this.setState({ isLoading: true });
			var ok = await sendValues(event.currentTarget.id, objetivo_id, user, admin_id);
			if (ok){
                this.setState({
                    isLoading: false,
                    isValid: true,                   
                    open: true
                });
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true
                });
            }

        } catch (error) {
            
            this.setState({
                isLoading: false,
                //serviceError: error,
                //isValid: false,
                //open: true
            });
        }
	}

	handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
	};


    render() {
		const { classes, className, ...rest } = this.props;
		const { alertas, dataError, isLoading, horarios, open, isValid } = this.state;

		const rootClassName = classNames(classes.root, className);
		const style = isLoading ? { display: 'none' } : {};
		const styleHidden = isLoading ? {} : { display: 'none' };
        if (!dataError) {
			return (<FormattedChart alertas={alertas} horarios={horarios} 
									style={style} styleHidden={styleHidden} 
									classes={classes} propsComp={this.props} 
									handleDeleted={this.handleDeleted} 
									open={open} isValid={isValid}
									handleClose={this.handleClose}/>)
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p>Error!</p>)
    
    }
}
function FormattedChart(props) {

    return (
        <div >
            <div style={props.styleHidden}>
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
							style={{color:"white"}}
                            align="center"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={34}
                            thickness={4}                            
                            />
                            <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style}>
				{props.alertas != undefined ?
					Object.keys(props.alertas).map((key) => (
						<Card >							
							{ props.alertas.status == 4?
								<div style={{float:"center", marginTop:"5%", marginBottom:"5%"}}>
									<Typography style={{float:"center", marginLeft:"10%"}} variant="h5" component="h2"  color="textSecondary" >
										Sin alertas asociadas
									</Typography>
								</div>
							:	<Grid container
									spacing={32}>
									<Grid
										item
										xs={10}
										sm={10}
										md={10}
										xl={10}>	

										<ButtonBase className={props.classes.cardInfo}  onClick={() => Graph(props.propsComp, props.alertas[key])}	>				
											<Grid
												container
												spacing={32}
											>	
																				
												<Grid
													item
													xs={9}
													sm={9}
													md={9}
													xl={9}	
																				
												>											
													<CardContent >
														<Typography className={props.classes.title} variant="h5" component="h5"  >
															{props.alertas[key].notificacion_destinatario.nombre}
														</Typography>
														<Typography variant="h6" component="h6" color="textSecondary">
															{props.alertas[key].notificacion_destinatario.destinatario}
														</Typography>
														<Typography variant="h6" component="h6" color="textSecondary">
															{Object.keys(props.horarios).map((keyScheduled) => {
																if (props.horarios[keyScheduled].horario_id == props.alertas[key].horario_id){
																	return props.horarios[keyScheduled].nombre
																}
															})}	
														</Typography>	
														<Grid
															container
															spacing={32}												
														>									
															<Grid
																item
																xs={3}
																sm={3}
																md={3}
																xl={3}									
															>
																<Typography className={props.classes.textField}>Global </Typography>
																{props.alertas[key].alerta_global == true?
																	<DoneIcon className={props.classes.icon}/>
																:null}
																
															</Grid>
															<Grid
																item
																xs={3}
																sm={3}
																md={3}
																xl={3}									
															>
																<Typography className={props.classes.textField}> Uptime </Typography>
																{props.alertas[key].alerta_uptime_ok == true?
																	<DoneIcon className={props.classes.icon}/>
																:null}
															</Grid>
															<Grid
																item
																xs={3}
																sm={3}
																md={3}
																xl={3}									
															>
																<Typography className={props.classes.textField}> Parcial </Typography>
																{props.alertas[key].alerta_parcial == true?
																	<DoneIcon className={props.classes.icon}/>
																:null}
															</Grid>
															<Grid
																item
																xs={3}
																sm={3}
																md={3}
																xl={3}									
															>
																<Typography className={props.classes.textField}> Umbral </Typography>
																{props.alertas[key].alerta_sla == true?
																	<DoneIcon className={props.classes.icon}/>
																:null}
															</Grid>
														</Grid>										
														
													</CardContent>
													
												</Grid>
												<Grid
													item
													xs={3}
													sm={3}
													md={3}
													xl={3}
													className={props.classes.field}
												>	
													<Card className={props.classes.cardInfoSend}>
														<Typography variant="body2" component="p">
															Desde: {props.alertas[key].envia_desde}
														</Typography>
														<Typography variant="body2" component="p">
															Hasta: {props.alertas[key].envia_hasta}
														</Typography>
													</Card>
														
													
												</Grid>	
											
											</Grid>	
										</ButtonBase>	
									</Grid>
									<Grid
										item
										xs={2}
										sm={2}
										md={2}
										xl={2}
									>	
										<IconButton 
												className={props.classes.btnDeleted}												
												id = {props.alertas[key].notificacion_id}
												onClick={props.handleDeleted}>
													<DeleteForeverIcon 
														color="primary"
														variant="outlined"/>
										</IconButton>	
										<Snackbar
                                                anchorOrigin={{
													vertical: 'top',
													horizontal: 'center',
                                                }}
                                                open={props.open}
                                                autoHideDuration={6000}
                                                onClose={props.handleClose}
                                            >
                                                <SnackbarContent
													className={props.isValid ? props.classes.snackContentOk
																: props.classes.snackContent}
                                                    aria-describedby="client-snackbar"
                                                    message={
														props.isValid ?
															<span id="client-snackbar" className={props.classes.message}>
																<CheckCircleIcon className={(props.classes.icon, props.classes.iconVariant)}/>
																Proceso Exitoso
															</span>
														:	<span id="client-snackbar" className={props.classes.message}>
																<ErrorIcon className={(props.classes.icon, props.classes.iconVariant)}/>
																Ha ocurrido un error, intente nuevamente
															</span>
                                                    }
                                                    action={[
                                                        <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                                                            <CloseIcon className={props.classes.icon}/>
                                                        </IconButton>
                                                    ]}
                                                />
                                        </Snackbar>
									</Grid>
								</Grid>
			
							}
							
						</Card>  
					))
				:null} 
            </div>
        </div>
    )
}


function Graph(props, alert) {
    props.onClick(alert)
}

NotificationsObjectiveList.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NotificationsObjectiveList);
